import { AuthLayoutContainer } from 'components/Layouts/AuthLayout';
import { Typography, Button, colors } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { setResetResult } from 'store/actions/authActions';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import resetPasswordMailSvg from 'assets/reset-password-mail.svg';

export const CheckEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onClickResend = useCallback(
    (e) => {
      dispatch(setResetResult(''));
      e.preventDefault();
    },
    [dispatch],
  );

  return (
    <AuthLayoutContainer showGrayLogo>
      <Container>
        <Box>
          <img
            src={resetPasswordMailSvg}
            width={113}
            height={111}
            alt="Reset password email sent"
          />
        </Box>

        <TextSection>
          <Title variant="h2">Check your email for reset password</Title>

          <Description variant="body1">
            If you haven't received an email within 5 minutes, check your spam folder or{' '}
            <a href="/" onClick={onClickResend}>
              click here
            </a>{' '}
            to resend.
          </Description>
        </TextSection>

        <Divider />

        <BackButton variant="primary" size="medium" onClick={() => navigate('/login')}>
          Back to Log in
        </BackButton>
      </Container>
    </AuthLayoutContainer>
  );
};

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TextSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled(Typography)`
  font-weight: 500 !important;
  color: ${colors.purple[900]};
`;

const Description = styled(Typography)`
  color: ${colors.neutral[900]};
  font-weight: 400 !important;
`;

const Divider = styled(Box)`
  border: 1px solid #f8f4f9;
  height: 0;
`;

const BackButton = styled(Button)`
  min-width: 100%;
`;
